(function() {
    'use strict';

    angular.module('stats')
        .controller('ProductionStatsController', ProductionStatsController);

    ProductionStatsController.$inject = ['$state', 'productionStatsDataSrvc', 'dateFormatConst', 'momentSrvc', 'datatableDefaultPageSizeValueConst', 'checkSearchSrvc', 'filterQuerySrvc'];

    function ProductionStatsController($state, productionStatsDataSrvc, dateFormatConst, momentSrvc, datatableDefaultPageSizeValueConst, checkSearchSrvc, filterQuerySrvc) {
        var self = this;

        self.loading = true;

        self.pageOpts = {
            count: undefined,
            page: 1,
            pageSize: datatableDefaultPageSizeValueConst
        };

        self.productionStatsRows = [];
        self.productionStatsCols = [{
            title: 'ID',
            value: 'pk',
            type: 'text',
            searchable: true,
            orderable: true
        }, {
            title: 'Użytkownik',
            value: 'name',
            type: 'text',
            searchable: true,
            orderable: true
        }, {
            title: 'Liczba produktów',
            value: 'order_products_count',
            type: 'text',
            orderable: true
        }, {
            title: 'Waga produktów',
            value: 'order_products_weight',
            type: 'decimal',
            orderable: true
        }, {
            title: 'Zapakowanych paczek',
            value: 'packed_count',
            type: 'text',
            orderable: true
        }, {
            title: 'Waga zapakowanych',
            value: 'packed_weight',
            type: 'decimal',
            orderable: true
        }, {
            title: 'Wysłanych paczek',
            value: 'sent_count',
            type: 'text',
            orderable: true
        }, {
            title: 'Niewysłanych paczek',
            value: 'not_sent_count',
            type: 'text',
            orderable: true
        }];

        self.searchQuery = {
            pk: null,
            name: null,
            ordering: null
        };

        self.dateFormat = dateFormatConst.datePickerWithoutDay;
        self.maxDate = momentSrvc.dateToStr(momentSrvc.getCurrentDate());
        self.filterData = {
            date: self.maxDate
        };

        self.pageChange = pageChange;
        self.onSearchQueryChange = onSearchQueryChange;
        self.changeFilter = changeFilter;

        activate();

        function activate() {
            self.filterData = filterQuerySrvc.initializeFilterData(self.filterData);
            self.pageOpts = filterQuerySrvc.initializePageOpts(self.pageOpts);
            self.searchQuery = filterQuerySrvc.initializeSearchQuery(self.searchQuery);
            filterQuerySrvc.setLocationParams();
            getProductionStats();
        }

        function getProductionStats(filterObj) {
            self.loading = true;

            if (!filterObj) {
                filterObj = {
                    page: self.pageOpts.page,
                    page_size: self.pageOpts.pageSize,

                    pk: self.searchQuery.pk,
                    name: self.searchQuery.name,
                    ordering: self.searchQuery.ordering,

                    date_year: self.filterData.date ?
                        momentSrvc.dateYear(self.filterData.date) : null,
                    date_month: self.filterData.date ?
                        momentSrvc.dateMonth(self.filterData.date) : null
                }
            }
            productionStatsDataSrvc.list(filterObj)
                .$promise
                .then(
                    function (response) {
                        self.productionStatsRows = response.results;
                        self.pageOpts.count = response.count;
                    },
                    function (response) {
                        if (response.status === 404 && filterObj.page !== 1) {
                            checkSearchSrvc.recall(filterObj, getProductionStats);
                        }
                    }
                )
                .finally(
                    function(response) {
                        self.loading = false;
                        return response;
                    }
                );
        }

        function pageChange() {
            filterQuerySrvc.updatePageOpts(self.pageOpts);
            filterQuerySrvc.setLocationParams();
            getProductionStats();
        }

        function onSearchQueryChange() {
            filterQuerySrvc.updateSearchQuery(self.searchQuery);
            filterQuerySrvc.setLocationParams();
            getProductionStats();
        }

        function changeFilter() {
            filterQuerySrvc.updateFilterData(self.filterData);
            filterQuerySrvc.setLocationParams();
            getProductionStats();
        }
    }
})();
